import { type Mock } from 'vitest';
import pino, { ChildLoggerOptions, Level, Logger } from 'pino';

const baseLogger = pino({
    base: { version: process.env.APP_VERSION ?? 'unknown' },
    censor: '[redacted]',
    formatters: {
        level: (label: Level) => {
            return {
                level: label.toUpperCase(),
            };
        },
    },
    level: process.env.PINO_LOG_LEVEL ?? process.env.NEXT_PUBLIC_PINO_LOG_LEVEL ?? 'info',
    messageKey: 'message',
    redact: [
        'password',
        'token',
        'authorization',
        '*.authorization',
        '*.headers.authorization',
        '*.headers.Authorization',
    ],
    timestamp: pino.stdTimeFunctions.isoTime,
} as any);

export function logger(file: string, bindings: pino.Bindings = {}, options: ChildLoggerOptions = {}): Logger {
    return baseLogger.child({ file: file, ...bindings }, options);
}

// MOCKING FUNCTIONS
export type LogMock = { debug: Mock; error: Mock; info: Mock; warn: Mock };
export type LoggerMock = Mock & { log: LogMock };
